module.exports = __webpack_public_path__ + "static/media/vegitables_71.71a94bdd.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_71.csv
// module id = 659
// module chunks = 0